import { render, staticRenderFns } from "./EstadoCuenta.vue?vue&type=template&id=4508844d&"
import script from "./EstadoCuenta.vue?vue&type=script&lang=ts&"
export * from "./EstadoCuenta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports